export interface ProfileResponse {
  firstname: string;
  lastname: string;
  language: string;
  email: string;
  phoneNumber: string;
  address: string;
  onboardingDone?: boolean;
}

export const getProfileLanguage = (language?: string) => {
  switch (language) {
    case 'en':
      return 'profile.general.information.language.en';
    case 'fr':
      return 'profile.general.information.language.fr';
    case 'nl':
      return 'profile.general.information.language.nl';
    default:
      return '';
  }
};
